import React, {useContext, useState,useEffect, useCallback} from "react";
import axios from "axios";
import {Section, Title} from "../../components/Common/PageElement";
import {Button, Col, Container, Form} from "react-bootstrap";
import {Route, Switch, useHistory, useRouteMatch,} from "react-router-dom";
import Fade from "react-reveal/Fade";


import {
    AnnotoolIntermediateBox, AnnotoolIntermediateText, AnnotoolIntermediateTitle,
    AnnotoolSearchRow,
    AnnotoolSearchRowNew,
    ButtonWrapper,
    DropdownWrapper,
    SearchBarWrapper
} from "./StyledAnnotoolSearch";
import ButtonComponent from "../../components/ButtonComponent";
import {DropdownMenu, Textbox} from "../../components/Form";
import {ANNOTOOL_INTERMEDIATE, ANNOTREE_DATABASE, INTERMEDIATE_APPLICATION, STOP_LOADER} from "../../services/Constant";
import {LoadContext} from "../../context/LoadContext";
import {TokenService} from "../../services/Token";
import {GENE_CLUSTER_SEARCH, INTERMEDIATE_API, SERVER_URL, TAXONOMY_DISTRIBUTION,} from "../../services/Config";

import AutocompleteWithDebounce from "./Autocomplete";
import Intermediate from "./Intermediate";
import TextField from "@material-ui/core/TextField";
import {Divider} from "@mui/material";
import * as PropTypes from "prop-types";
import LoadingOverlay from "react-loading-overlay";
import CheckboxTree from "react-checkbox-tree";
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

// Import debounce from lodash for efficient search
import debounce from 'lodash.debounce';


// Annotool search is used for gene cluster search and connect Annoview and Annotree
const AnnotoolSearch = () => {
    const { load,setLoad } = useContext(LoadContext);
    let { path } = useRouteMatch();
    let history = useHistory();
    const [searchTerm, setSearchTerm] = useState('');


    // const [coverage, setCoverage] = useState('10000');
    const [contextRange, setContextRange] = useState('10000');

    const [databaseValue, setDatabaseValue] = useState(
        ANNOTREE_DATABASE[1]["id"]
    );

    const [idList, setIdList] = useState([]);

    const [maxLength,setMaxLength] = useState(0)

    // **************************************************** divider ***************************************

    const [pageToken, setPageToken] = useState('')
    const genomeLimit = '10000';

    // **************************************************** divider ***************************************

    // tree checked will be the real tree hits that return to the backend
    const [isLoading, setIsLoading] = useState(false);

    const [treeData, setTreeData] = useState([]);

    // original tree data is used to anchor the tree
    const [originalTreeData, setOriginTreeData] = useState([]);
    const [treeChecked, setTreeChecked] = useState([]);
    const [isFiltered, setIsFiltered] = useState(false);
    // const [filteredTreeData, setFilteredTreeData] = useState([]);

    const [expanded, setExpanded] = useState([]);
    const [checked, setChecked] = useState([]);
    const [limitLevel, setLimitLevel] = useState('');
    const [treeInfo, setTreeInfo] = useState(null)
    const [showTree, setShowTree] = useState(true);
    const [genomeUpperLimit, setGenomeUpperLimit] = useState(2000);





    // **************************************************** divider ***************************************
    // tree related:

    // Search function to highlight nodes based on the search term
    // Search function to filter nodes based on the search term and maintain structure
    const searchTreeFilter = (term, nodes) => {
        return nodes
            .map((node) => {
                const match = node.label.toLowerCase().includes(term.toLowerCase());

                if (match) {
                    return { ...node };
                }
                if (node.children) {
                    const filteredChildren = searchTreeFilter(term, node.children);
                    if (filteredChildren.length > 0) {
                        return { ...node, children: filteredChildren };
                    }
                }
                return null;
            })
            .filter((node) => node !== null);
    };

    // Handle search button click - trigger full search and display result
    const handleSearchClick = () => {
        setIsFiltered(true); // Set filter mode to true
        if (searchTerm === '') {
            setTreeData(originalTreeData); // Reset to original nodes if search is empty
        } else {
            const filtered = searchTreeFilter(searchTerm, originalTreeData);
            setTreeData(filtered); // Update with filtered nodes
            expandFilteredNodes(filtered); // Expand all nodes in the filtered result
        }
    };

    // Function to expand all nodes that are filtered (preserve structure)
    const expandFilteredNodes = (nodes) => {
        let expandedNodes = [];
        const traverse = (nodes) => {
            for (const node of nodes) {
                expandedNodes.push(node.value);
                if (node.children) {
                    traverse(node.children);
                }
            }
        };
        traverse(nodes);
        setExpanded(expandedNodes);
    };

    // Debounced function to handle search input changes
    const debouncedSearch = useCallback(
        debounce((term) => {
            setSearchTerm(term);
        }, 100),
        []
    );

    useEffect(() => {
        return () => {
            // Cleanup debounce when component unmounts
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    function findSubstrings(arr1, arr2) {
        let result = [];

        for (let str2 of arr2) {
            for (let str1 of arr1) {
                if (str2.includes(str1)) {
                    result.push(str2);
                    break; // Move to the next string in arr2 once a match is found
                }
            }
        }

        return result;
    }

    const getNodeIdsWrapper = (nodes) =>{
        let treeInfo = getNodeIds(nodes)


        if(treeInfo['num'] === 1 && treeInfo['nodes'].length === 0){
            // console.log('hello')
            treeInfo['num'] = 0
        }
        return treeInfo
    }

    const getNodeIds = (nodes) => {
        // if(!nodes){
        //     return
        // }

        let treeInfo = {'num':0,'nodes':[]}

        if(nodes){
            nodes.forEach(({ title,value, children }) => {
                // console.log(title)
                if(!children){
                    treeInfo['num'] += 1

                    treeInfo['nodes']  = [...treeInfo['nodes'], value]
                }
                else{
                    let tempTreeInfo = getNodeIds(children)
                    treeInfo['num'] += tempTreeInfo['num']
                    treeInfo['nodes']  = [...treeInfo['nodes'], value, ...tempTreeInfo['nodes']]
                }
                //
                // ids = [...ids, value, ...getNodeIds(children)];
            });
        }

        return treeInfo;
    }

    const updateChecked = (treeChecked) =>{
        setChecked(treeChecked)
        let checkedDetails = findSubstrings(treeChecked, treeInfo['nodes'])


        let checkedHits =
            checkedDetails.
            map((item,i)=>{
                let checkedSplit = item.split('/')

                // hard coded, length is 10, reason:
                // 1* (acc/bac) + 7*taxonomy(domain,phylum....) + 1* genome_id + 1*gene_id = 10
                if(checkedSplit.length === 9){
                    return item
                }

                // // if only search for gtdb, then length is 9
                // if(checkedSplit.length === 9){
                //     return item
                // }
                return null
            }).filter((item)=>{

                return !!item;

            })

        // console.log(checkedHits)
        setTreeChecked(checkedHits)
        // setGtdbTreeChecked(gtdbHits)

    }


    const isValidIntContextRange = (str) => {
        const intVal = parseInt(str, 10);
        return Number.isInteger(intVal) && intVal >= 0
    };

    const updateIds = (newOptionList) =>{
        setIdList(newOptionList)
    }

    const changeDatabaseValue = (e)=>{
        // console.log(e.target.value)
        setDatabaseValue(e.target.value)
    }

    const levelOrder = ['domain','phylum','class','order','family','genus','species', 'genome', 'gene']
    const truncate_tree = (treeNode,limitLevel) =>{

        if(treeNode){
            let curLevel = treeNode['title']

            // if the taxonomy level is deeper than the limit
            // eg. if the current taxonomy level is 'species', and the limitLevel is genus, then
            // the function return and truncate the species level.

            if(levelOrder.indexOf(curLevel) === levelOrder.indexOf(limitLevel)){
                treeNode['children'] = []
                return treeNode
            }
            else{
                // let curChildren = treeNode['children']
                let curChildren = treeNode['children']
                // console.log(curChildren)
                if(curChildren){
                    curChildren.forEach((child,idx)=>{
                        // return truncate_tree(child,limitLevel)
                        curChildren[idx] = truncate_tree(child,limitLevel)
                    })
                }

            }

        }
        return treeNode
    }

    const taxonomySearch = (e) =>{
        if(idList.length === 0){
            alert('please enter your ids')
            return
        }

        setIsLoading(true);



        const ids = idList.map(string => {
            // Splits the string at ' ---' and takes the first part
            return string.split('---')[0];
        });


        const formData = new FormData();

        formData.append("db", databaseValue);
        formData.append("ids", ids);
        formData.append("limit", genomeLimit);

        window.scrollTo({
            top: 300, // Set this to the pixel value you want to scroll to
            behavior: 'smooth', // This adds smooth scrolling animation
        });



        axios
            .post(SERVER_URL + TAXONOMY_DISTRIBUTION, formData)
            .then((response) => {
                console.log('submit success')
                // setTreeData(response.data.track_data)
                const curTreeInfo = getNodeIdsWrapper(response.data.track_data)
                setTreeInfo(curTreeInfo)

                let copyTree = JSON.parse(JSON.stringify(response.data.track_data))

                let truncatedTree = [truncate_tree(copyTree[0],response.data.limit_level)]


                setOriginTreeData(truncatedTree)
                setTreeData(truncatedTree)
                setExpanded(curTreeInfo['nodes'])

                setTreeChecked([])
                setIsLoading(false);
                // console.log(treeInfo)
                // console.log(treeData)

            })
            .catch((e) => {
                console.log('Annotool taxonomy search error')
                console.log(e)
                setIsLoading(false);

                // if(e.response.status === 400){
                //     alert(e.response.data.error);
                // }

            });

    }

// **************************************************** divider ***************************************


    const search = () => {
        // console.log(databaseValue)


        if(idList.length === 0){
            alert('Please enter your ids.')
            return
        }

        if(checked.length === 0){
            alert('Please choose genomes of interest in the tree above (click "find taxonomy").')
            return
        }

        if(checked.length > genomeUpperLimit){
            alert(`Please choose number of genomes less than ${genomeUpperLimit}`)
            return
        }


        if (contextRange === "" || !isValidIntContextRange(contextRange)) {
            alert('Please enter the correct context range value as an integer.')
            return
        }

        // check if context range is between 5kb to 30kb:
        let intContextRange = parseInt(contextRange)
        if(intContextRange < 5000 || intContextRange > 30000){
            alert('Context range con only between 5000 and 30000')
            return
        }


        const ids = idList.map(string => {
            // Splits the string at ' ---' and takes the first part
            return string.split('---')[0];
        });

        const token = TokenService(40);

        setPageToken(token)
        setLoad({'value':ANNOTOOL_INTERMEDIATE,'token':token,'database':databaseValue,'path':path});


        const formData = new FormData();

        formData.append("token", token);
        formData.append("db", databaseValue);
        formData.append("ids", ids);
        // formData.append("sequence_text", dataText);
        // formData.append("evalue", evalue);
        formData.append("range", contextRange);
        formData.append("limit", genomeLimit);

        formData.append("tree_data",treeChecked)



        axios
            .post(SERVER_URL + GENE_CLUSTER_SEARCH, formData)
            .then((response) => {
                // console.log('get response')
                setLoad({'value':STOP_LOADER,'token':''});
                console.log('submit success')

                history.push({
                    pathname: `${path}/intermediate`,
                    state: {
                        intermediateData: response.data.track_data,
                        token: token,
                        databaseValue: databaseValue,
                        limit_level: response.data.limit_level,
                        contextRange:contextRange,
                        ids:ids,
                    },
                });

            })
            .catch((e) => {
                console.log('Annotool search error')
                console.log(e.response)
                setLoad({'value':STOP_LOADER,'token':'','database':''});
                // if(e.response.status === 400){
                //     alert("Sorry no cluster found!");
                // }

                if(e.response.status === 400){
                    alert(e.response.data.error);
                }



            });
    };



    return (
        <Switch>
            <Route exact path={path}>
                <Section height="more_than_full" >
                    <Container>

                        {/*<Title>Annotree Search</Title>*/}
                        <Title>Search GTDB for annotations</Title>
                        <div>

                            <h2 style={{fontSize: '24px'}}>
                                <span style={{fontWeight: 'bold', color: '#2f8ae1'}}>Step 1: </span>
                                Select taxa containing protein annotation(s).
                            </h2>


                            <Divider style={{margin: '20px 0', borderColor: "#2f8ae1", borderWidth: '2px'}}/>

                        </div>


                        <AnnotoolSearchRowNew>
                            {/* Database Dropdown */}
                            <DropdownWrapper>
                                <DropdownMenu
                                    options={ANNOTREE_DATABASE}
                                    val="id"
                                    label="name"
                                    formlabel="Database"
                                    onChange={changeDatabaseValue}
                                    value={databaseValue}
                                />
                            </DropdownWrapper>

                            {/* Search Bar */}
                            <SearchBarWrapper>
                                <AutocompleteWithDebounce
                                    updateIds={updateIds}
                                    database={databaseValue}
                                />
                            </SearchBarWrapper>

                            {/* Search Button */}
                            <ButtonWrapper>
                                <ButtonComponent
                                    disabled={idList.length === 0}
                                    onClick={taxonomySearch}
                                >
                                    Find taxonomy
                                </ButtonComponent>
                            </ButtonWrapper>
                        </AnnotoolSearchRowNew>


                        <LoadingOverlay
                            active={isLoading}
                            spinner
                            text='Searching... '
                        >
                            <AnnotoolSearchRow>
                                <Col>
                                    <AnnotoolIntermediateBox
                                        disabled={!showTree}
                                        // onClick={() => {
                                        //     handleShowTree(true);
                                        // }}
                                    >
                                        <AnnotoolIntermediateTitle>
                                            Select taxonomy of interest
                                        </AnnotoolIntermediateTitle>
                                        {originalTreeData.length === 0 ? (
                                            <AnnotoolIntermediateText>
                                                {/*There are no significant matches*/}
                                                Enter one or more annotations to find genomes containing them.
                                            </AnnotoolIntermediateText>
                                        ) : (
                                            <>
                                                <AnnotoolIntermediateText>
                                                    {/*Total selected: {checked.length-1 < 0? 0:checked.length-1}{" "}*/}

                                                    {/*Total selected: {checked.length}{" "}*/}
                                                    Total selected: {treeChecked.length}{" "}
                                                    {/*matches (genomes)*/}
                                                    matches (genomes).
                                                    Please select number of genomes less than {genomeUpperLimit}.

                                                </AnnotoolIntermediateText>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    marginBottom: '20px'
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search nodes..."
                                                        value={searchTerm}
                                                        onChange={(e) => {
                                                            setIsFiltered(false); // Reset filter mode if typing again
                                                            debouncedSearch(e.target.value);
                                                        }}
                                                        style={{padding: '5px', width: '300px', marginRight: '10px'}}
                                                    />
                                                    <button onClick={handleSearchClick}
                                                            style={{padding: '5px 10px', cursor: 'pointer'}}>
                                                        Search
                                                    </button>
                                                </div>
                                                <CheckboxTree
                                                    disabled={!showTree}
                                                    checked={checked}
                                                    expanded={expanded}
                                                    nodes={treeData}
                                                    // onCheck={(val) => setChecked(val)}
                                                    onCheck={(val) => updateChecked(val)}
                                                    onExpand={(val) => setExpanded(val)}
                                                    iconsClass="fa5"
                                                    showNodeIcon={false}
                                                />
                                            </>
                                        )}
                                    </AnnotoolIntermediateBox>
                                </Col>
                            </AnnotoolSearchRow>
                        </LoadingOverlay>


                        <div>

                            <h2 style={{fontSize: '24px'}}>
                                <span style={{fontWeight: 'bold', color: '#2f8ae1'}}>Step 2: </span>
                                Find genomic regions from selected taxa that contain protein annotation(s).
                            </h2>

                            <Divider style={{margin: '20px 0', borderColor: "#2f8ae1", borderWidth: '2px'}}/>

                        </div>

                        <AnnotoolSearchRow>

                            <Col>
                                {/*there is a latency when user enter the value, this because the tree data is large for the frontend*/}
                                {/*<Textbox*/}
                                {/*    label="Context range (between 5k and 30k bases)"*/}
                                {/*    variant="outlined"*/}
                                {/*    fullWidth*/}
                                {/*    // value={contextRange}*/}
                                {/*    value={contextRange}*/}
                                {/*    onChange={(e)=>{*/}
                                {/*        setContextRange(e.target.value)}}*/}

                                {/*/>*/}
                                <Textbox
                                    defaultvalue={contextRange}
                                    formlabel="Context range or Window length (between 5k and 30k bases).
                                    This parameter will be used to find all windows that contain your annotation(s)."
                                    // formlabel={"Minimum query coverage of the alignment"}
                                    placeholder="Enter your context range for searching"
                                    onChange={(e) =>
                                        setContextRange(e.target.value)
                                    }
                                    // showDetail={true}
                                />
                            </Col>
                        </AnnotoolSearchRow>
                        <AnnotoolSearchRow>
                            <Col md={{span: 6, offset: 3}}>

                                <ButtonComponent
                                    fill
                                    disabled={
                                        idList.length === 0
                                    }
                                    onClick={search}
                                >
                                    Search
                                </ButtonComponent>
                            </Col>
                        </AnnotoolSearchRow>
                    </Container>
                </Section>
            </Route>
            {/*<Route path={`${path}/combinationIntermediate`}>*/}
            {/*    <Intermediate />*/}
            {/*</Route>*/}
            <Route path={`${path}/intermediate`}>
                <Intermediate/>
            </Route>
        </Switch>
    );
};

export default AnnotoolSearch;